import { CSSProperties } from 'react'

export const modernCard: CSSProperties = {
  background: 'white',
  borderRadius: '16px',
  padding: '32px',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  transition: 'all 0.3s ease',
  border: '1px solid rgba(226, 232, 240, 0.8)'
}

export const modernCardHover: CSSProperties = {
  ...modernCard,
  transform: 'translateY(-4px)',
  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
}

export const modernButton: CSSProperties = {
  borderRadius: '12px',
  padding: '12px 32px',
  fontSize: '1rem',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease'
}

export const glassEffect: CSSProperties = {
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(10px)',
  borderRadius: '20px',
  border: '1px solid rgba(255, 255, 255, 0.3)',
  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)'
}

export const gradientBackground: CSSProperties = {
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  minHeight: '100vh',
  position: 'relative'
}

export const featureCard: CSSProperties = {
  background: 'white',
  borderRadius: '20px',
  padding: '40px 30px',
  textAlign: 'center',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
  transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  border: '1px solid rgba(226, 232, 240, 0.8)',
  height: '100%'
}

export const modernInput: CSSProperties = {
  borderRadius: '12px'
}

export const sectionDivider: CSSProperties = {
  margin: '80px auto',
  maxWidth: '200px',
  height: '4px',
  background: 'linear-gradient(90deg, transparent, #667eea, transparent)',
  border: 'none',
  borderRadius: '2px'
}
